import React from "react";

const NoImage = ()=>{
    return(
        <div className="no-image-wrapper">
            <span>No Image</span>
        </div>
    );
}
export default NoImage;